export default __webpack_public_path__ + "static/media/header-background-mobile.d9b81311.avif";